import { useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { Button } from "@mui/material";
import useAuth from "../../../../hooks/useAuth";
import { apiVariable } from "../../../../api/apiVariable";
import GenericFormPopup from "../../../Fleet/GenericFormPopup/GenericFormPopup";
import StatusSnackbar from "../../../General/StatusSnackbar/StatusSnackbar";
import { updateLeadFieldConfiguration } from "../../../../formConfigs/FleetCRM/leadFieldConfig";

const UpdateLeadPopup = ({ lead }: { lead: any }) => {
  const [open, setOpen] = useState(false);
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const queryClient = useQueryClient();
  const { token } = useAuth();

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleSnackbarClose = () => setStatus("idle");

  const leadMutation = useMutation({
    mutationFn: (data: any) =>
      axios.put(`${apiVariable}/updateLead`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    onSuccess: () => {
      setStatus("success");
      handleClose();
      queryClient.invalidateQueries({ queryKey: ["leads"] });
    },
    onError: (error: any) => {
      setStatus("error");
      setErrorMessage(error.response?.data || "Failed to update lead");
    },
  });

  const submitHandler = (data: any) => {
    leadMutation.mutate(data);
  };

  const leadInitialValues = {
    id: lead.id,
    company: lead.company,
    city: lead.city,
    dot: lead.dot,
    mc: lead.mc,
    status: lead.status,
    assignedTo: lead.assignedTo || "Steve Hoffmann",
    contactMethod: lead.contactMethod,
    contactedDate: lead.contactedDate && lead.contactedDate.split("T")[0],
    interestedIn: lead.interestedIn,
    isWarm: lead.isWarm ? true : false,
  };

  return (
    <>
      <Button variant="contained" color="primary" onClick={handleOpen}>
        Update Lead
      </Button>
      <GenericFormPopup
        initialValues={leadInitialValues}
        formFields={updateLeadFieldConfiguration}
        title="Update Lead"
        onSubmit={submitHandler}
        open={open}
        onClose={handleClose}
        loading={leadMutation.isPending}
      />

      <StatusSnackbar
        status={status}
        successMessage="Lead updated successfully"
        errorMessage={errorMessage}
        handleClose={handleSnackbarClose}
      />
    </>
  );
};

export default UpdateLeadPopup;
